import React, { useEffect } from "react";
import styles from './Game.module.css';
import { Board } from "./Board";
import Cell from "./Cell";
import { useSelector, useDispatch } from "react-redux";
import {
    checkMove,
    move,
    changeturn,
    selectGame,
    selectMoves,
    selectTurn,
    finished,
    checkMoves,
    selectLastMove,
    newGame,
} from './gameSlice';

export function Game() {
    const moves = useSelector(selectMoves);
    const board = useSelector(selectGame);
    const turn = useSelector(selectTurn);
    const ended = useSelector(finished);
    const lastMove = useSelector(selectLastMove);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(checkMove({ board, lastMove, turn }));
        dispatch(changeturn());
        dispatch(checkMoves(board));
    },// eslint-disable-next-line 
        [board]
    );

    const handleMove = (movement) => {
        dispatch(move(movement))
    }

    return (
        <div className={styles.gameContainer}>
            <div className={styles.gameTitleContainer}>
                <span className={styles.titleIcon}>♦</span>
                <h1 className={styles.gameTitle}>
                    Four in Line Board
                    <div className={styles.titleUnderline}></div>
                </h1>
                <span className={styles.titleIcon}>♦</span>
            </div>
            
            {ended ? (
                <div className={styles.status}> 
                    <span>Congratulations </span>
                    <Cell played={turn === 'r' ? 'b' : 'r'} />
                    <span> has won</span> 
                </div>
            ) : (
                <div className={styles.status}>
                    <span><Cell played={turn} /> Plays</span>
                </div>
            )}
            
            <div className={styles.gameArea}>
            <div className={styles.buttonList}>
    {Array.from({ length: 7 }, (_, index) => (
        <button
            key={index + 1}
            onClick={() => handleMove(index + 1)}
            disabled={!moves[index] || ended}
            className={styles.buttonCell}
        >
            <Cell played={''} />
        </button>
    ))}
</div>

                <Board game={board} />
            </div>

            <button 
                className={styles.newGameButton} 
                onClick={() => dispatch(newGame())}
            >
                New Game
            </button>
        </div>
    );
}
